export const LOGIN_START = "LOGIN_START";
export const LOGIN = "LOGIN";
export const LOGIN_ERROR = "LOGIN_ERROR";

export const LOGOUT = "LOGOUT";

export const GET_USER = "GET_USER";
export const RESET_LOGIN_LOADER = "RESET_LOGIN_LOADER";
